export const isMD5 = (text: string) => {
  const md5Regex = /^[a-fA-F0-9]{32}$/

  return md5Regex.test(text)
}
